import { StatusBadge, type StatusBadgeProps } from "./StatusBadge";

/**
 * Selo de "Projeto conceito": marca fictícia criada como demonstração do tipo
 * de site que o Eliveuton entrega. Aparece em todo lugar onde um case com
 * `case_study.concept = true` é listado, para ninguém ler como cliente real.
 */
export function ConceptBadge({
  shape = "tag",
  ...props
}: Omit<StatusBadgeProps, "tone" | "children">) {
  return (
    <StatusBadge
      tone="notice"
      shape={shape}
      title="Marca fictícia criada como demonstração"
      {...props}
    >
      Conceito
    </StatusBadge>
  );
}
